//Etiquetas en español para posición y rol de jugador (Admin Chachos)
export const POSITION_LABEL = {
  goalkeeper: "Arquero",
  defender: "Defensor",
  midfielder: "Volante",
  forward: "Delantero",
};

export const ROLE_LABEL = {
  team: "Jugador fijo",
  extra: "Refuerzo",
  supporter: "Hinchada",
};
